<template>
  <div id="apps">
    <div class="first">
      <div style="display: flex; position: absolute; left: 12px">
        <img
          class="leftimg"
          src="@/assets/images/guide.png"
          @click="backPage"
        />
        <div class="logo"><img src="@/assets/images/logozx.png" /></div>
      </div>
      <p style="color: #fff">
        {{ title
        }}<!--游记资讯-->
      </p>
    </div>
    <div>
      <div class="top_title">
        <div class="top_title_card">
          <h2>{{ article.title }}</h2>
          <div class="top_title_view">
            <span v-if="article.author">{{ article.author }}</span>
            <span v-if="article.source">{{ article.source }}</span>
            <span>{{ spiltS }}</span>
            <div class="icon" v-if="article.onclick">
              <img src="@/assets/images/look.png" alt="" />
              <span>{{ article.onclick }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="conterss" v-html="html"></div>
    </div>
    <div class="foter" v-if="html"></div>
  </div>
</template>
<script>
import { youjizxDital, holidaynews, holidaymeetdetail } from "@/api/travel";
export default {
  data() {
    return {
      show: false,
      article: {},
      title: "",
      cate: "",
      city: JSON.parse(localStorage.getItem("regionList")).re_name,
      meetdetails: {},
    };
  },
  computed: {
    spiltS() {
      // 判断this.article.created_at是否存在，因为数据是异步步请求，不然会报错
      if (this.article.created_at) {
        return this.article.created_at.split(" ")[0];
      }
    },
    html() {
      if (this.article.content) {
        return this.article.content.content;
      } else if (this.article.news_content) {
        return this.article.news_content;
      }
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
  },
  created() {
    if (this.$route.params.type == 3) {
      this.title = "活动资料";
      document.title = this.city + "-活动资料";
      holidaymeetdetail({
        id: this.$route.params.id,
        holid: this.$route.params.ids,
      }).then((res) => {
        // console.log(res);
        this.meetdetails = res.meetdetails;
        this.article = {
          news_content: res.meetdetails.meet_content,
          title: res.meetdetails.meet_name,
        };
      });
    } else if (this.$route.params.type == 2) {
      this.title = "活动资讯";
      document.title = this.city + "-活动资讯";
      holidaynews({
        id: this.$route.params.id,
        holid: this.$route.params.ids,
      }).then((res) => {
        // console.log(res);
        this.article = res.news;
        this.article = {
          news_content: this.article.news_content,
          title: this.article.news_name,
          created_at: this.article.news_time,
        };
      });
    } else if (this.$route.params.type == 1) {
      this.title = "新闻资讯";
      document.title = this.city + "-攻略";
      youjizxDital({
        cate: this.$route.params.ids,
        id: this.$route.params.id,
      }).then((res) => {
        this.article = res.article;
        this.cate = res.cate.parent.name;
      });
    } else if (this.$route.params.type == 4) {
      this.title = "攻略路书";
      document.title = this.city + "-攻略";
      youjizxDital({
        cate: this.$route.params.ids,
        id: this.$route.params.id,
      }).then((res) => {
        this.article = res.article;
        this.cate = res.cate.parent.name;
      });
    } else if (this.$route.params.type == 5) {
      this.title = "攻略路书";
      document.title = this.city + "-攻略";
      youjizxDital({
        cate: this.$route.params.ids,
        id: this.$route.params.id,
      }).then((res) => {
        this.article = {
          title: res.cate.name,
          created_at: res.cate.created_at,
          onclick: res.cate.click,
          news_content: res.cate.jpg,
          author: res.cate.edit,
          source: res.cate.jianzhi
        };
        this.cate = res.cate.parent.name;
      });
    }
  },
};
</script>
<style scoped>
#apps {
  /* background: #e0592b; */
  background: #fff;
}
.first {
  height: 58px;
  padding: 0 18px;
  background: #e0592b;
  overflow: hidden;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.leftimg {
  width: 14px;
  height: 24px;
  margin-right: 10px;
}
.logo img {
  width: 52px;
}
.top_title {
  background: url("../../assets/images/bg3.png") top no-repeat;
  background-size: 100%;
  background-color: #fff;
  padding-bottom: 20px;
}
.top_title_card {
  background-color: #fff;
  width: 90%;
  margin: 0 auto;
  box-shadow: 4px 3px 4px rgb(119, 118, 118, 0.3);
  border-radius: 10px;
  padding: 10px;
}
.top_title_card h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.top_title_view {
  display: flex;
  align-items: center;
}
.top_title_view span {
  font-size: 12px;
  margin-right: 5%;
}
.icon {
  display: flex;
  align-items: center;
}
.icon img {
  width: 16px;
  margin-right: 2px;
}
.conterss {
  background-color: #fff;
  /* position: absolute;
  left: 30px;
  right: 30px; */
  padding: 0 20px;
}
.foter {
  width: 100%;
  height: 50px;
  /* background: #e0592b;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%; */
  background: url("../../assets/images/bg3.png") center no-repeat;
  background-size: 100% 100%;
  background-color: #fff;
  /* position: absolute;
  bottom: 0; */

  transform: rotate(180deg);
}
#apps .contentss > p {
  text-indent: 2em;
}
</style>
<style>
.conterss img {
  width: 100%;
}
</style>